import React from 'react'
import ResetPasswordTemplate from '../../templates/ResetPassword/ResetPasswordTemplate'

const ResetPassword = () => {
  return (
    <ResetPasswordTemplate />
  )
}

export default ResetPassword